import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import App from './App.vue'
import axios from 'axios'
import VueTheMask from 'vue-the-mask'

Vue.use(VueSweetalert2);  //https://alligator.io/vuejs/vue-sweetalert2/
Vue.use(require('vue-moment'));
Vue.use(VueTheMask);  //https://github.com/vuejs-tips/vue-the-mask

Vue.prototype.$http = axios

new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js